module.exports = __webpack_public_path__ + "img/3.b51b26e8.svg";